import { createSlice } from '@reduxjs/toolkit';

// Customer payments run through the recoverable commerce checkout, not the retired payment endpoints.
const initialState = {
    orderId: null, amount: 0, loading: false, error: null,
    paymentStatus: null, transactionId: null,
};
const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        resetPayment: () => ({ ...initialState }),
        clearError: state => { state.error = null; },
    },
});
export const { resetPayment, clearError } = paymentSlice.actions;
export default paymentSlice.reducer;
